import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import {removeNonDigits} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class GeneralLocations extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            fromSection: '',
            toSection: '69',
            fromClub: '',
            toClub: '299',
            report: 'dist'
        });
    }

    fields = [];
    render() {
        return <div className="general-members">
            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <label className={'header'}>Filtréring (valgfrit)</label>}
            <div className={'upper-container'}>
                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromSection"
                            id="fromSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.fromSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[0] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til sektion</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toSection"
                            id="toSection"
                            maxLength="2"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{2}"}]}
                            value={this.state.toSection}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            ref={instance => { this.fields[1] = instance; }}
                        />
                    </div>
                </div> : null}
                {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <div className={'attribute-row'}>
                    <div className={'attribute-pair'}>
                        <label>Fra forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="fromClub"
                            id="fromClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.fromClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[2].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.fromClub)) this.setState({fromClub: this.state.fromClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[2] = instance; }}
                        />
                    </div>
                    <div className={'attribute-pair'}>
                        <label>Til forening</label>
                        <UserFieldElement
                            dataType={UserFieldDataType.regex}
                            placeholder=""
                            className="field-1 very-small-field"
                            containerClassName="display-inline-block"
                            name="toClub"
                            id="toClub"
                            maxLength="3"
                            options={[{key: UserFieldDataType.regex.REGEX_OPTION_KEY , value: "[0-9]{3}"}]}
                            value={this.state.toClub}
                            autoCheckErrors={true}
                            hideErrWhenFocused={true}
                            hideErrUntilFocused={true}
                            onChange={this.onDigitInputFieldChange}
                            onBlur={() => {
                                this.fields[3].setState({focused: false, visited: true});
                                if (/^[0-9]{1,2}$/.test(this.state.toClub)) this.setState({toClub: this.state.toClub.padStart(3, '0')});
                            }}
                            ref={instance => { this.fields[3] = instance; }}
                        />
                    </div>
                </div>}
            </div>
            <label className={'header'}>Listetype</label>
            <div className={'lower-container'}>
                <div className={'list-type-container'}>
                    <div className="option-container">
                        <input id="listtype0" name="listtype" type="radio" checked={this.state.report === 'dist'} onClick={() => this.setState({report: 'dist'})}/> <label htmlFor="listtype0">Afstandsliste</label>
                    </div>
                    <div className="option-container">
                        <input id="listtype1" name="listtype" type="radio" checked={this.state.report === 'member-location'} onClick={() => this.setState({report: 'member-location'})}/> <label htmlFor="listtype1">Længde og breddekoordinater</label>
                    </div>
                    <div className="option-container">
                        <input id="listtype2" name="listtype" type="radio" checked={this.state.report === 'member-control'} onClick={() => this.setState({report: 'member-control'})}/> <label htmlFor="listtype2">GPS-registrering</label>
                    </div>
                    <div className="option-container">
                        <input id="listtype3" name="listtype" type="radio" checked={this.state.report === 'stations'} onClick={() => this.setState({report: 'stations'})}/> <label htmlFor="listtype3">Stationsliste</label>
                    </div>
                </div>
            </div>
        </div>
    }

    onDigitInputFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: removeNonDigits(e.target.value)});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    getReportOptions = () => {
        const errors = [];
        const isValid = this.allInputValid();
        if (!isValid) {
            errors.push('Der er fejl i et eller flere rapporteringsvalg.');
            this.fields.forEach((field) => {
                field.setState({visited: true});
            });
        }

        if (this.state.fromSection !== '' && this.state.toSection !== '' && this.state.fromSection > this.state.toSection) errors.push('Fra sektion kan ikke være større end Til sektion.');
        if (this.state.fromClub    !== '' && this.state.toClub    !== '' && this.state.fromClub    > this.state.toClub)    errors.push('Fra forening kan ikke være større end Til forening.');

        let options = {
            fromSection: this.state.fromSection === '' ? null : this.state.fromSection,
            toSection:   this.state.toSection   === '' ? null : this.state.toSection  ,
            fromClub:    this.state.fromClub    === '' ? null : this.state.fromClub   ,
            toClub:      this.state.toClub      === '' ? null : this.state.toClub     ,
            report :   this.state.report,
        };

        return {
            errors: errors,
            options: options
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(GeneralLocations);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/GeneralLocations.js